<template>
  <div id="algorithm-detail">
    <template v-if="product">
      <ProductBanner
          :product="product"
          use-apply-button="true"
      ></ProductBanner>
    </template>

    <div class="inner">
      <div class="swiper-container swiper-lnb">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">소개</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">멤버쉽 설명</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">사용효과</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">REVIEW</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">BY ZILZU</a></div>
        </div>
      </div>

      <div class="inner-wrap">
        <div class="content">
          <div class="content1">
            <p class="sub">멤버쉽 트레이닝 <br class="dp-no">한마디로 요약란</p>
            <p class="exp">
              멤버쉽 트레이닝 간략한 소개 멤버쉽 트레이닝 간략한 소개<br/>
              멤버쉽 트레이닝 간략한 소개 멤버쉽 트레이닝 간략한 소개<br/>
              멤버쉽 트레이닝 간략한 소개 멤버쉽 트레이닝 간략한 소개<br/>
            </p>
          </div>

          <div class="content2" id="section2">
            <h3 class="tit"><strong>확률</strong>에 기반한 퀀트 트레이딩</h3>
            <div class="box-container">
              <div class="box">
                <div class="box-content"><b>차트에 대한 해설</b>통계에 기반한 차트 해설</div>
              </div>
              <div class="box">
                <div class="box-content"><b>매수, 매도 타이밍</b>매수 매도 타이밍 설명</div>
              </div>
              <div class="box">
                <div class="box-content"><b>최신정보 제공</b>매집 알림, 온체인 데이터, 뉴스 실시간 제공</div>
              </div>
            </div>
            <p class="exp">
              멤버쉽 트레이닝은 [차트 해설 / 매수, 매도 타이밍, 최신정보 제공] 으로 이루어져 있습니다.<br/>
              멤버쉽 트레이닝을 통해 확률에 기반한 손익비를 이해하고, 코인 트레이딩의 주기를 이해함으로써 안정된 트레이딩이 가능합니다.
            </p>
          </div>

          <div class="content2">
            <h3 class="tit">멤버쉽 트레이닝 <strong>이런분들께 추천</strong>드립니다</h3>
            <p class="exp">멤버쉽 트레이닝 추천하는 이유 멤버쉽 트레이닝의 성과. 멤버쉽 트레이닝 추천하는 이유 멤버쉽 트레이닝의 성과.<br/>
              멤버쉽 트레이닝 추천하는 이유 멤버쉽 트레이닝의 성과멤버쉽 트레이닝 추천하는 이유 멤버쉽 트레이닝의 성과.<br/>
              멤버쉽 트레이닝 추천하는 이유 멤버쉽 트레이닝의 성과멤버쉽 트레이닝 추천하는 이유 멤버쉽 트레이닝의 성과멤버쉽 트레이닝 추천하는 이유 멤버쉽 트레이닝의 성과.</p>
            <p class="exp"><b> 😫 매매에서 오는 스트레스를 견디기 힘든분:</b><br/>
              중장기적으로 형성된 추세가 앞으로도 유지 될 것이라고 기대하고
              그 추세의 방향과 같은 방향으로 포지션을 구축하는 전략
            </p>
            <p class="exp"><b> 😫 뇌동매매가 잦은분:</b><br/>
              주가의 현재의 값을 반영하지 않아 시그널이 뒤늦게 발생하는 지표
              보통 캔들의 시가로 처리 되는 경우가 많음
            </p>
          </div>

          <div class="content4">
            <h3 class="tit">사용효과</h3>
            <div class="tabs">
              <Swiper
                  class="swiper-tabs"
                  :slides-per-view="4"
                  :space-between="10"
              >
                <swiper-slide :class="{on: currentTab === 'BTC'}" v-on:click="currentTab = 'BTC'">BTC</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'ETH'}" v-on:click="currentTab = 'ETH'">ETH</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'XRP'}" v-on:click="currentTab = 'XRP'">XRP</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'BCH'}" v-on:click="currentTab = 'BCH'">BCH</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'LTC'}" v-on:click="currentTab = 'LTC'">LTC</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'ADA'}" v-on:click="currentTab = 'ADA'">ADA</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'EOS'}" v-on:click="currentTab = 'EOS'">EOS</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'TRX'}" v-on:click="currentTab = 'TRX'">TRX</swiper-slide>

              </Swiper>
            </div>
            <div class="tabs-cnt">
              <div id="btc" v-show="currentTab === 'BTC'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">BTC/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 73919 만원</li>
                      <li>현재 존버시드 : 4399 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <img src="~@/assets/images/trendformer/btckrw.png" alt="">
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">BTC/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 106171 $</li>
                      <li>현재 존버시드 : 27587 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/btcusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
              <div id="eth" v-show="currentTab === 'ETH'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">ETH/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 1967 만원</li>
                      <li>현재 존버시드 : 133 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/ethkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">ETH/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 14425 $</li>
                      <li>현재 존버시드 : 10320 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/ethusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
              <div id="xrp" v-show="currentTab === 'XRP'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">XRP/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 2016 만원</li>
                      <li>현재 존버시드 : 32 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/xrpkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">XRP/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 849 $</li>
                      <li>현재 존버시드 : 99 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/xrpusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
              <div id="bch" v-show="currentTab === 'BCH'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">BCH/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 739 만원</li>
                      <li>현재 존버시드 : 16 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <img src="~@/assets/images/trendformer/bchkrw.png" alt="">
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">BCH/USD, 12H, COINBASE</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 388 $</li>
                      <li>현재 존버시드 : 18 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/bchusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
              <div id="eos" v-show="currentTab === 'EOS'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">EOS/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 532 만원</li>
                      <li>현재 존버시드 : 29 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <img src="~@/assets/images/trendformer/eoskrw.png" alt="">
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">EOS/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 828 $</li>
                      <li>현재 존버시드 : 138 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/eosusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
              <div id="ltc" v-show="currentTab === 'LTC'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">LTC/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 346 만원</li>
                      <li>현재 존버시드 : 38 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <img src="~@/assets/images/trendformer/ltckrw.png" alt="">
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">LTC/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 20751 $</li>
                      <li>현재 존버시드 : 4631 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/ltcusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
              <div id="ada" v-show="currentTab === 'ADA'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">ADA/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 765 만원</li>
                      <li>현재 존버시드 : 219 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <img src="~@/assets/images/trendformer/adakrw.png" alt="">
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">ADA/USD, 12H, BINANCE</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 1501 $</li>
                      <li>현재 존버시드 : 271 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/adausd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
              <div id="trx" v-show="currentTab === 'TRX'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">TRX/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 343 만원</li>
                      <li>현재 존버시드 : 70 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/trxkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                  <li style="margin-bottom: 10px">
                    <p class="tit">TRX/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 121 $</li>
                      <li>현재 존버시드 : 65 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/trendformer/trxusd.png" alt=""/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 트랜드포머의 시그널대모 매매 했을 시의 시드변화 그래프
                      <br/><br/>
                      빨간선은 존버 했을 시의 시드변화 그래프
                      <br/><br/>
                      트랜트 포머는 모든 시드를 투입하여 매매 할 때 마다 수수료 0.1%, 슬리피즈 0.1% 적용시의 시드 변화 그래프
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="content5">
            <h3 class="tit">REVIEW</h3>
            <ReviewCardList column="2"></ReviewCardList>
          </div>

          <div class="content6">
            <h3 class="tit">DISTRIBUTED BY ZILZU</h3>
            <p class="exp">‘정통 트레이딩을 트렌디하게’ 라는 슬로건으로 어려운 차트이론 보다는 간단하지만 의미있는 통계/원리를 기반한 트레이딩 원칙과 아이디어, 그리고 노하우를 공유합니다. </p>
            <div class="swiper-container swiper-sns swiper-sns">
              <div class="swiper-wrapper">
                <div class="swiper-slide"><a href="https://t.me/tradingviewmania"><i class="ico-tel"></i>텔레그램</a></div>
                <div class="swiper-slide"><a href="https://open.kakao.com/o/sDFpV9X"><i class="ico-talk"></i>카카오톡</a></div>
                <div class="swiper-slide"><a href="https://cafe.naver.com/tradingviewmania"><i class="ico-cafe"></i>네이버카페</a></div>
                <div class="swiper-slide"><a href="https://kr.tradingview.com/u/ssabu/"><i class="ico-trade"></i>트레이딩뷰</a></div>
                <div class="swiper-slide"><a href="https://cafe.naver.com/nexontv"><i class="ico-bitman"></i>비트맨</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductBanner from "../components/ProductBanner";
import apiClient from "../../utils/instance";
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper-bundle.css'
import ReviewCardList from "../container/ReviewCardList";
import ImageModal from "../components/ImageModal";

export default {
  name: "AutoBuySellBasic",
  props: ["productCode"],
  components: {ImageModal, ReviewCardList, ProductBanner, Swiper, SwiperSlide},
  data() {
    return {
      product: null,
      currentTab: 'BTC'
    }
  },
  methods: {},
  async mounted() {
    this.product = (await apiClient.instance.get('/products/' + this.productCode)).data
  }
}
</script>

<style>
@import '~@/assets/css/main.css';
@import '~@/assets/css/reset.css';
@import '~@/assets/css/content.css';

.faq-exp .img-wrap {
  float: left;
  width: 26%;
  height: 156px;
  border-radius: 8px;
  background: #fff;
}

.faq-exp .tx-wrap {
  float: left;
  width: 74%;
  padding-left: 6%;
  box-sizing: border-box;
}

@media screen and (max-width: 767px) {
  .box-container {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}

.box-container {
  margin-top: 15px;
  display: grid;
  grid-gap: 50px;
  grid-template-columns: repeat(3, 1fr);
}

.box {
  display: table;
  height: 80px;
  border-radius: 8px;
  background: -webkit-linear-gradient(-45deg, #39393D 45%, #2F2F32 0%);
}

.box-content {
  display: table-cell;
  height: inherit;
  text-align: center;
  vertical-align: middle;
}

b {
  display: block;
  font-size: 14px;
}

</style>

